import { FC } from 'react'
import { Modal } from 'antd'
import DnsRecordsSection from './DnsRecordsSection'

type Props = {
 // Domain whose zone records are shown; null = closed
 domain: { id: number; domain: string } | null
 onClose: () => void
}

// "Manage DNS Records" / "Records": live zone records for one connected domain
const DnsRecordsModal: FC<Props> = ({ domain, onClose }) => (
 <Modal
  visible={!!domain}
  title={
   <>
    DNS Records
    <span className="modal-domain">{domain?.domain}</span>
   </>
  }
  onCancel={onClose}
  footer={null}
  width={720}
  className="domain-dns-modal"
  destroyOnClose
 >
  {domain && <DnsRecordsSection domainId={domain.id} />}
 </Modal>
)

export default DnsRecordsModal
